import type { MessageDescriptor } from 'react-intl-next';
import { defineMessages } from 'react-intl-next';

import type { EmojiId } from '@atlaskit/emoji/types';

const i18n = defineMessages({
	thumbsUp: {
		id: 'experiment-omnibar.omni-bar.reaction.thumbsUp',
		defaultMessage: 'Thumbs up',
		description: 'Tooltip text for thumbs up reaction emoji',
	},
	clap: {
		id: 'experiment-omnibar.omni-bar.reaction.clap',
		defaultMessage: 'Clap',
		description: 'Tooltip text for clapping hands reaction emoji',
	},
	fire: {
		id: 'experiment-omnibar.omni-bar.reaction.fire',
		defaultMessage: 'Fire',
		description: 'Tooltip text for fire reaction emoji',
	},
	heart: {
		id: 'experiment-omnibar.omni-bar.reaction.heart',
		defaultMessage: 'Heart',
		description: 'Tooltip text for heart reaction emoji',
	},
	astonished: {
		id: 'experiment-omnibar.omni-bar.reaction.astonished',
		defaultMessage: 'Astonished',
		description: 'Tooltip text for astonished face reaction emoji',
	},
});

export interface ReactionConfig extends EmojiId {
	tooltipDescriptor: MessageDescriptor;
}

export const DEFAULT_REACTIONS: ReactionConfig[] = [
	{ id: '1f44d', shortName: ':thumbsup:', fallback: '👍', tooltipDescriptor: i18n.thumbsUp },
	{ id: '1f44f', shortName: ':clap:', fallback: '👏', tooltipDescriptor: i18n.clap },
	{ id: '1f525', shortName: ':fire:', fallback: '🔥', tooltipDescriptor: i18n.fire },
	{ id: '2764', shortName: ':heart:', fallback: '❤️', tooltipDescriptor: i18n.heart },
	{ id: '1f632', shortName: ':astonished:', fallback: '😲', tooltipDescriptor: i18n.astonished },
];

export const EMOJI_SIZE = 20;

export const RESOURCED_EMOJI_COMPACT_HEIGHT = 16;

export const findReactionByShortName = (shortName: string): ReactionConfig | undefined => {
	return DEFAULT_REACTIONS.find((reaction) => reaction.shortName === shortName);
};

export const getShortNameForEmojiId = (emojiId: string): string => {
	const config = DEFAULT_REACTIONS.find((r) => r.id === emojiId);
	return config?.shortName ?? `:emoji-${emojiId}:`;
};

export const formatUnknownEmojiName = (shortName: string): string => {
	return shortName
		.replace(/^:/, '')
		.replace(/:$/, '')
		.split('_')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
};
